module.exports = __webpack_public_path__ + "img/avatar-1.8c399b25.png";